import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
// import vertexShader from './shaders/terrain/vertex.glsl'
// import fragmentShader from './shaders/terrain/fragment.glsl'

import vertexShader from './shaders/terrain-heliware/vertex.glsl'
// import vertexcShader from './shaders/terrain-heliware/vertexog.glsl'
import fragmentShader from './shaders/terrain-heliware/fragment.glsl'


/**
 * Base
 */

// Drag & Drop
document.addEventListener('dragover', (event) => {
    event.stopPropagation();
    event.preventDefault();
    // Style the drag-and-drop as a "copy file" operation.
    event.dataTransfer.dropEffect = 'copy';
});

document.addEventListener('drop', (ev) => {
    ev.stopPropagation();
    ev.preventDefault();

    if (ev.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (let i = 0; i < Math.min(1, ev.dataTransfer.items.length); i++) {
            // If dropped items aren't files, reject them
            if (ev.dataTransfer.items[i].kind === 'file') {
                const file = ev.dataTransfer.items[i].getAsFile();
                createTerrain(file);
            }
        }
    } else {
        // Use DataTransfer interface to access the file(s)
        for (let i = 0; i < Math.min(ev.dataTransfer.files.length); i++) {
            createTerrain(ev.dataTransfer.files[i]);
        }
    }
});

// Loading Manager
const loadingManager = new THREE.LoadingManager(() => {
}, (_, loaded, total) => {
    console.log((loaded / total) * 100);
}, () => {
    console.log(err)
});

// Debug
const params = {
    x: 0,
    y: 0,
    z: 0,
    uExaggeration: 1,
    path: '7266.png',
};
const gui = new dat.GUI()
// gui.hide();

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color(0, 0, 0);

// pointer
const raycaster = new THREE.Raycaster();
const pointer = new THREE.Vector2();

// Helper
// let helper;
const geometryHelper = new THREE.ConeBufferGeometry(0.01, 0.05, 3);
geometryHelper.translate(0, 0.025, 0);
geometryHelper.rotateX(Math.PI / 2);
const helper = new THREE.Mesh(geometryHelper, new THREE.MeshNormalMaterial());
scene.add(helper);

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.up.set(0, 0, 1);

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Terrain mesh
 */

const updateCameraControl = (mesh) => {
    // mesh.position.z -= 0.2;
    mesh.geometry.computeBoundingSphere();
    const bDShpere = mesh.geometry.boundingSphere;
    const center = bDShpere.center;
    const radius = bDShpere.radius;
    camera.position.set(center.x + radius, center.y + radius, center.z + radius);
    camera.lookAt(center);
    controls.target = center;
}

// Geometry
const geometry = new THREE.PlaneBufferGeometry(1, 1, 255, 255);

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader(loadingManager);
const imageLoader = new THREE.ImageLoader(loadingManager);
const terrainTexture = textureLoader.load(params.path);
let terrainImgCtx;

const updateTextureCanvas = (path) => {
    imageLoader.load(path, (image) => {
        const textureCanvas = document.createElement('canvas');
        textureCanvas.width = image.width;
        textureCanvas.height = image.height;
        terrainImgCtx = textureCanvas.getContext('2d');
        terrainImgCtx.drawImage(image, 0, 0);
        const opositions = geometry.getAttribute('position').array;
        const heights = [];
        const { data } = terrainImgCtx.getImageData(0, 0, image.width, image.height);
        const positions = new Float32Array(opositions.length);
        for (let index = 0; index < (data.length / 4); index++) {
            const i4 = index * 4;
            const r = data[i4 + 0];
            const g = data[i4 + 1];
            const b = data[i4 + 2];

            const max = Math.max(r, g, b);
            heights.push(
                max / 256
            );
        }
        for (let index = 0; index < (opositions.length / 3); index++) {
            const i3 = index * 3;
            positions[i3] = opositions[i3];
            positions[i3 + 1] = opositions[i3 + 1];
            positions[i3 + 2] = heights[index] * params.uExaggeration;
        }
        geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
        updateCameraControl(mesh);
    })
}

updateTextureCanvas(params.path);

// Material
const material = new THREE.ShaderMaterial({
    vertexShader: vertexShader,
    fragmentShader: fragmentShader,
    // wireframe: true,
    side: THREE.DoubleSide,
    uniforms: {
        uTexture: { value: terrainTexture },
        uExaggeration: { value: 1 }
    }
});

const mesh = new THREE.Mesh(geometry, material)
scene.add(mesh);

// Create texture from file
const createTerrain = (file) => {
    if (file.type && !file.type.startsWith('image/')) {
        console.log('File is not an image.', file.type, file);
        return;
    }

    const fileReader = new FileReader();

    fileReader.onloadend = () => {
        params.path = fileReader.result;
        updateTextureCanvas(params.path);
        const terrainTexture = textureLoader.load(params.path);
        material.uniforms.uTexture.value = terrainTexture;
    }

    fileReader.onerror = (err) => {
        console.log('Read File Error ', err);
    }

    fileReader.readAsDataURL(file);
}

gui.add(params, 'uExaggeration').name('Exaggeration Factor').min(0.01).max(5).step(0.001).onFinishChange(() => {
    updateTextureCanvas(params.path);
});

const guiX = gui.add(params, 'x').name('X');
const guiY = gui.add(params, 'y').name('Y');
const guiZ = gui.add(params, 'z').name('Z');

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * GPU Picking
 */
// const pickingScene = new THREE.Scene();
// pickingScene.background = new THREE.Color(0, 0, 0);
// pickingScene.add(mesh.clone());
// // must be identical to the size of the drawn scene
// const pickingTexture = new THREE.WebGLRenderTarget(window.innerWidth, window.innerHeight);
// const pixelBuffer = new Uint8Array(4);


window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    // pickingTexture.setSize(sizes.width, sizes.height);
});

window.addEventListener('pointermove', (ev) => {
    // // render the picking scene
    // renderer.setRenderTarget(pickingTexture)
    // renderer.render(pickingScene, camera);
    // renderer.setRenderTarget(null);

    // const x = ev.clientX * Math.min(window.devicePixelRatio, 2);
    // const y = pickingTexture.height - ev.clientY * Math.min(window.devicePixelRatio, 2);

    // // read the selected pixel
    // renderer.readRenderTargetPixels(pickingTexture, x, y, 1, 1, pixelBuffer);

    // const id =(pixelBuffer[0] << 16) | (pixelBuffer[1] << 8) | (pixelBuffer[2]);
    // // console.log(id);

    pointer.x = (ev.clientX / sizes.width) * 2 - 1;
    pointer.y = -(ev.clientY / sizes.height) * 2 + 1;

    if (!!mesh && terrainImgCtx) {
        raycaster.setFromCamera(pointer, camera);
        const intersections = raycaster.intersectObject(mesh, true);
        if (intersections.length > 0) {
            helper.lookAt(intersections[0].face.normal);
            helper.position.copy(intersections[0].point);
            params.x = intersections[0].point.x;
            params.y = intersections[0].point.y;
            params.z = intersections[0].point.z;
            guiX.updateDisplay();
            guiY.updateDisplay();
            guiZ.updateDisplay();
        }
    }
});



/**
 * Animate
 */
const clock = new THREE.Clock()
const tick = () => {
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update();

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()
